import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import image1 from '../../assets/img/solucoes/img-solucoes_fluxo-de-atendimento-radiologicas-1.jpg'
import image2 from '../../assets/img/solucoes/img-solucoes_fluxo-de-atendimento-radiologicas-2.jpg'


class AtendimentoClinicas extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <h2>Nossas Soluções</h2>
                        <h3>Atendimento em Clínicas Radiológicas</h3>
                        <span class="saude">Saúde</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row d-lg-flex align-items-lg-center">
                      <div class="col-12 col-lg-6">
                        {/* <div id="galeria" class="owl-carousel">
                          <img src={"../assets/img/solucoes/img-solucoes_fluxo-de-atendimento-radiologicas-1.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_fluxo-de-atendimento-radiologicas-2.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          </div> */}
                          <div style={{width: '480px', height: '400px'}} class="img-fluid m-auto" >
                              <BackgroundSlider
                                  images={[image1, image2]}
                                  duration={5}
                                  transition={0.5}
                              />
                              {/* <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img> */}
                          </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <h3>Descrição:</h3>
                        <p>Nossa solução foi desenvolvida com o objetivo de melhorar o fluxo de atendimento dentro de clinicas radiológicas. Através da rastreabilidade do paciente desde o momento da sua entrada na clínica até o final de todo o ciclo de exames, proporcionamos maior agilidade no tempo de atendimento, menor tempo de espera, garantindo uma experiência diferenciada na jornada do paciente e a clínica com um nível superior atendimento e gestão.</p>

                        <iframe width="100%" height="300" src="https://www.youtube.com/embed/n9r7XnXoudU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div>
                    </div>

                      <div class="row">
                        <div class="col-12 mt-5">
                          <h3>Aplicação:</h3>
                          <p>Hospitais, e clínicas radiológicas</p> 
                          
                          <h3>Principais funcionalidades e benefícios:</h3>
                        </div>


                        <div class="col-12 col-md-6">
                          <ul>
                            <li>Contribui para cumprir os agendamentos na hora marcada</li>
                            <li>Agilidade em todo o processo de  atendimento</li>
                            <li>Paciente com sensação de não estar esquecido</li>
                            <li>Rastreabilidade do paciente em todo o fluxo de atendimento;</li>
                            <li>Melhor gestão do fluxo de pacientes e consequente aumento de capacidade operacional;</li>
                            <li>Sistema intuitivo e fácil de operar</li>
                            <li>Sistema em nuvem totalmente integrado e sincronizado com o his/ris da clinica ou hospital</li>

                          </ul>
                        </div>

                        <div class="col-12 col-md-6">
                          <ul>
                            <li>Sincronismo automatizado dos agendamentos do His/Ris</li>
                            <li>Dashboard de salas de exames disponíveis em tempo real</li>
                            <li>Dashboard de exames realizados e a realizar por pacientes</li>
                            <li>Visualização das informações de forma simples e intuitiva.</li>
                            <li>Alertas visuais de tempo médio de atendimento</li>
                            <li>Alertas visuais de tempo de espera acima do determinado.</li>
                            <li>SW desenvolvido Web-based (Não requer APP)</li>
                            <li>Pesquisa de satisfação</li>
                          </ul>

                          <br></br><br></br>
                        </div>
                      </div>

                      <div id="accordionFluxo" class="fluxo-de-usuario mt-5">
                        <div class="fluxo-container">
                                  <div id="Fluxo1" class="fluxo-item">
                                    <a href="#" class="btn-fluxo" data-toggle="collapse" data-target="#fluxo_1" aria-expanded="true" aria-controls="fluxo_1"><span>Passo 1</span> Integração dos Sistemas</a>
                                  </div>

                                  <div id="Fluxo2" class="fluxo-item">
                                    <a href="#" class="btn-fluxo" data-toggle="collapse" data-target="#fluxo_2" aria-expanded="true" aria-controls="fluxo_2"><span>Passo 2</span> Entrada - Vínculo</a>
                                  </div>

                                  <div id="Fluxo3" class="fluxo-item">
                                    <a href="#" class="btn-fluxo" data-toggle="collapse" data-target="#fluxo_3" aria-expanded="true" aria-controls="fluxo_3"><span>Passo 3</span> Atendimento</a>
                                  </div>

                                  <div id="Fluxo4" class="fluxo-item">
                                    <a href="#" class="btn-fluxo" data-toggle="collapse" data-target="#fluxo_4" aria-expanded="true" aria-controls="fluxo_4"><span>Passo 4</span> Realização de Exames</a>
                                  </div>

                                  <div id="Fluxo5" class="fluxo-item">
                                    <a href="#" class="btn-fluxo" data-toggle="collapse" data-target="#fluxo_5" aria-expanded="true" aria-controls="fluxo_5"><span>Passo 5</span> Saída - Desvínculo</a>
                                  </div>
                                </div>
                                  
                                <div class="col-12">
                                <div id="fluxo_1" class="collapse melhoria-collapse mt-3" aria-labelledby="Fluxo1" data-parent="#accordionFluxo">
                                      <div class="card-body">
                                        <div class="row">
                                          <div class="col-12 col-lg-4">
                                            <img src={"../assets/img/fluxo-de-atendimento/passo1.jpg"} alt="" class="img-fluid"></img>
                                          </div>
                                          <div class="col-12 col-lg-8">
                                            <p>O ITechFlow busca  os agendamentos do His/Ris automaticamente (5 em 5min)</p>

                                              <p>Refresh manual a qualquer momento para atualização de informações alteradas no sistema de origem.</p>
                                            </div>
                                        </div>
                                      </div>
                                  </div>

                                  <div id="fluxo_2" class="collapse melhoria-collapse mt-3" aria-labelledby="Fluxo2" data-parent="#accordionFluxo">
                                      <div class="card-body">
                                          <div class="row">
                                            <div class="col-12 col-lg-4">
                                              <img src={"../assets/img/fluxo-de-atendimento/passo2.jpg"} alt="" class="img-fluid"></img>
                                            </div>
                                          
                                            <div class="col-12 col-lg-8">
                                              <p>O paciente é identificado via Toten ou concierge com atendimento e informações personalizadas e diferenciadas sobre sua jornada desde o início.</p>

                                              <p>O colaborador ou sistema define se o atendimento é normal, prioridade ou Emergência.</p>

                                              <p>O paciente é orientado imediatamente sobre tempos de espera e hora agendada.</p>

                                              <p>O paciente poderá ser vinculado no ItechFlow por crachá, BLE (automático), senha com código de barras (semiautomático) ou manualmente por tablet ou celular.</p>
                                            </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div id="fluxo_3" class="collapse melhoria-collapse mt-3" aria-labelledby="Fluxo3" data-parent="#accordionFluxo">
                                      <div class="card-body">
                                          <div class="row">
                                            <div class="col-12 col-lg-4">
                                            <img src={"../assets/img/fluxo-de-atendimento/passo3.jpg"} alt="" class="img-fluid"></img>
                                          </div>
                                          
                                          <div class="col-12 col-lg-4">
                                            {/* <p>Tela de gestão a vista (No.2) <br></br>
                                              Atendente visualiza tela de Atendimento (No.3) <br></br>
                                              Chama o paciente para seu guichê:</p>
                                              <ul>
                                                <li>Próximo</li>
                                                <li>Próximo Prioridade</li>
                                                <li>Próximo Emergência</li>
                                                <li>Escolher</li>
                                              </ul>

                                              <p>Atendente, na tela No.4, pode:</p>
                                              <ul>
                                                <li>Iniciar</li>
                                                <li>Ausente</li>
                                              </ul> */}
                                              <p>Identificação automática de presença do paciente na sala de atendimento.</p>

                                              <p>Sistema inteligente de gestão de fila e usa critério pré definido em função de:</p>
                                              <ul>
                                                <li>Atendimento Prioritário</li>
                                                <li>Hora do agendamento</li>
                                                <li>Hora de chegada</li>
                                                <li>Tipo de exame</li>
                                              </ul>

                                            </div>

                                          <div class="col-12 col-lg-4">
                                            {/* <p>Ao final do atendimento:</p>
                                              <ul>
                                                <li>Finalizar</li>
                                                <li>Pausar</li>
                                                <li>Obs: Qualquer informação relevante</li>
                                              </ul>

                                              <p>Sistema usa o critério pré definido de gestão de fila em função de:</p>
                                              <ul>
                                                <li>Atendimento Prioritário</li>
                                                <li>Hora do Agendamento</li>
                                                <li>Hora da chegada</li>
                                                <li>Tipo de exame</li>
                                              </ul> */}
                                              <p>Atendente monitora na tela de atendimento todas as informações consolidadas.</p>
                                              
                                              <p>Atendente é auxiliada também por sistema automático de alertas de atrasos de atendimento.</p>

                                              <p>Tudo isso permite maior agilidade no processo de encaminhamento e conforto do paciente.</p>
                                            </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div id="fluxo_4" class="collapse melhoria-collapse mt-3" aria-labelledby="Fluxo4" data-parent="#accordionFluxo">
                                      <div class="card-body">
                                          <div class="row">
                                            <div class="col-12 col-lg-4">
                                            <img src={"../assets/img/fluxo-de-atendimento/passo4.jpg"} alt="" class="img-fluid"></img>
                                          </div>
                                          
                                          <div class="col-12 col-lg-4">
                                            {/* <p>Tela da Modalidade (CT, US, MG, RM, etc) N0.5
                                              <ul>
                                                <li>Pode ser salas vazias e cheias</li>
                                                <li>Pacientes em espera</li>
                                                <li>Alarmes de tempos</li>
                                                <li>Alarme de ociosidade da sala</li>
                                              </ul>
                                            </p>

                                            <p>Tela do médico: No.5*
                                              <ul>
                                                <li>Seus Pacientes</li>
                                                <li>Alarmes de tempo</li>
                                                <li>Aviso de paciente na sala</li>
                                              </ul>
                                            </p> */}
                                            <p>Atendente com interface simplificada sobre o status de atendimento de cada paciente.</p>

                                            <p>Pode ver quais salas estão vazias e cheias</p>

                                            <p>Pacientes em espera</p>

                                            <p>Alarmes de tempos</p>

                                            <p>Alarme de ociosidade de sala</p>
                                          </div>

                                          <div class="col-12 col-lg-4">
                                            {/* <p>Auxiliar de sala utiliza a tela da Modalidade (5) e/ou Tela de Tracking do Paciente (No.6):
                                              <ul>
                                                <li>Protocolo (encher bexiga)</li>
                                                <li>Cancelar</li>
                                                <li>Finalizar</li>
                                              </ul>
                                            </p>

                                            <p>Se o paciente tiver outro exame, vai estar indicado qual será <br></br>
                                            Se for o último exame:
                                              <ul>
                                                <li>Aviso de desvincular</li>
                                              </ul>
                                            </p> */}
                                            <p>Médico auxiliado com avisos proativos de presença do paciente na sala.</p>

                                            <p>Tela do médico possui:</p>
                                            <ul>
                                                <li>Seus pacientes</li>
                                                <li>Alarmes de tempo</li>
                                                <li>Aviso de Paciente na sala</li>
                                                <li>Sistema informa sobre o próximo exame.</li>
                                              </ul>
                                            </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div id="fluxo_5" class="collapse melhoria-collapse mt-3" aria-labelledby="Fluxo5" data-parent="#accordionFluxo">
                                      <div class="card-body">
                                          <div class="row">
                                            <div class="col-12 col-lg-4">
                                            <img src={"../assets/img/fluxo-de-atendimento/passo5.jpg"} alt="" class="img-fluid"></img>
                                          </div>
                                          
                                          <div class="col-12 col-lg-4">
                                            {/* <p>No último exame será avisado para que o auxiliar de sala recolha o crachá e desvincule o paciente do sistema ItechFlow</p>

                                            <p>Mesmo assim, caso não haja a entrega do crachá por esquecimento, pode haver uma urna na saída da  clinica onde o paciente ou colaborador pode depositar o crachá para desvinculo automático.</p> */}
                                            <p>Se o paciente tiver outro exame, vai estar indicado qual será.</p>
                                            <p>Se for o último exame:</p>
                                            <p>Aviso de DESVINCULAR</p>
                                            <p>No último exame será avisado para que a auxiliar de sala recolha o crachá e desvincule o paciente no sistema ItechFlow</p>
                                            <p>Mesmo assim, caso não haja a entrega do crachá por esquecimento, pode haver uma urna na saída da clínica onde o paciente ou colaborador pode depositar o crachá para desvinculo automático</p>
                                          </div>
                                          <div class="col-12 col-lg-4">
                                            <p>No final do atendimento o sistema contempla <b>pesquisa de satisfação</b> sobre o atendimento do paciente, onde irá ajudar a:</p>
                                            <ul>
                                              <li>Aproximar-se dos clientes.</li>
                                              <li>Identificar eventuais erros.</li>
                                              <li>Promover melhorias.</li>
                                              <li>Direcionar os investimentos.</li>
                                              <li>Fidelizar os clientes que irão referenciar a clínica ou o hospital.</li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                                </div>
                      </div>
                  </div>
                </section>
                
            
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default AtendimentoClinicas;

